import { map } from 'lodash';
const DEFAULT_PARAMS = {
  toolbar: true,
  location: true,
  directories: false,
  status: false,
  menubar: false,
  scrollbars: true,
  resizable: false,
  copyhistory: false,
  width: 0,
  height: 0,
  top: 0,
  left: 0
};
function buildParams(params) {
  return map(params, (value, key) => {
    if (value === true) {
      value = 'yes';
    } else if (value === false) {
      value = 'no';
    }
    return `${key}=${value}`;
  }).join(',');
}
export function openTab(url, overrides, name, onClose) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (name === void 0) {
    name = '_blank';
  }
  const params = {
    ...DEFAULT_PARAMS,
    ...overrides
  };
  const _params = buildParams(params);
  const tab = window.open(url, name, _params);
  if (!tab) {
    return;
  }
  if (onClose) {
    const timer = setInterval(() => {
      if (tab.closed) {
        clearInterval(timer);
        onClose();
      }
    }, 300);
  }
  try {
    if (tab.moveTo) {
      tab.moveTo(params.left, params.top);
    }
    tab.focus();
  } catch (e) {
    // Access Denied Exception in IE11.
  }
}
export function openBlankTab(url) {
  window.open(url, '_blank');
}
//# sourceMappingURL=open-tab.js.map